import { type FC } from 'react'
import { useIntl } from 'react-intl'

import GenericDialog from '@DS/components/components/dialog/GenericDialog'

import DialogLinkButton from './_internal/DialogLinkButton'

type WidgetErrorDialogProps = {
  isOpen?: boolean
  onClose: VoidFunction
}

const WidgetErrorDialog: FC<WidgetErrorDialogProps> = ({ isOpen = false, onClose, ...rest }) => {
  const { formatMessage } = useIntl()

  return (
    <GenericDialog
      {...rest}
      variant="error_system"
      message={formatMessage({ id: 'genericErrorTitle' })}
      annotations={formatMessage({ id: 'genericErrorSubtitle' })}
      hasToDisableCloseOnBackdropClick
      hasToDisableCloseOnEscapeKeyDown
      show={isOpen}
      onClose={onClose}
      defaultAction={{
        label: formatMessage({ id: 'refresh_page' }),
        onClick: () => {
          window.location.reload()
          onClose()
        },
      }}
      actions={[
        {
          label: formatMessage({ id: 'close' }),
          onClick: onClose,
        },
      ]}
      externalLinkComponent={DialogLinkButton}
      linkButtonComponent={DialogLinkButton}
    />
  )
}

export default WidgetErrorDialog
